import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import vImg from "../../images/video/img03.jpg";
import vImg2 from "../../images/video/polygon02.png";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerDraas from "../../images/banners/banner_draas.png";

const DisasterRecoveryPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Disaster Recovery
                      </span>
                      <h2 className="title">
                        Proteção total contra desastres com recuperação
                        <br />
                        instantânea garantida
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerDraas} alt="DRaaS Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Disaster Recovery Somar: Sua Empresa Sempre Protegida
                </h2>
                <p className="sd-content">
                  O Disaster Recovery da Somar Cloud oferece proteção
                  empresarial de nível mundial contra falhas de sistema,
                  desastres naturais, ataques cibernéticos e qualquer evento que
                  possa interromper suas operações. Com RTO (Recovery Time
                  Objective) de minutos e RPO (Recovery Point Objective) próximo
                  a zero, garantimos que sua empresa continue operando mesmo nas
                  situações mais adversas.
                </p>
                <br />
                <p className="sd-content">
                  Nossa solução utiliza replicação em tempo real para múltiplos
                  datacenters geograficamente distribuídos, orquestração
                  automatizada de failover e testes periódicos não-disruptivos.
                  Com tecnologia de ponta e storage síncronos enterprise,
                  asseguramos integridade total dos dados e continuidade
                  absoluta dos serviços críticos do seu negócio.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Exclusividades Somar Cloud:</strong> Failover
                  automático baseado em IA, testes de DR sem impacto na
                  produção, relatórios de compliance automáticos, recuperação
                  granular por aplicação, e runbooks personalizados. Nossa
                  metodologia de Disaster Recovery como Serviço (DRaaS) elimina
                  investimentos em infraestrutura secundária mantendo proteção
                  máxima.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Metodologia de Proteção</h2>
                <p className="sd-content">
                  Nossa abordagem estruturada de Disaster Recovery garante
                  proteção abrangente com planos testados e validados
                  regularmente.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Análise de Riscos</h3>
                  <p className="xb-item--contact">
                    Avaliação de vulnerabilidades e definição de criticidade.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Design de Proteção</h3>
                  <p className="xb-item--contact">
                    Arquitetura de DR customizada com RTO/RPO específicos.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Implementação</h3>
                  <p className="xb-item--contact">
                    Deploy de replicação e automação de failover.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Testes Contínuos</h3>
                  <p className="xb-item--contact">
                    Validação periódica e otimização dos planos de DR.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">Benefícios do Disaster Recovery</h2>
                  <p className="sd-content">
                    Proteja seu negócio contra qualquer tipo de interrupção com
                    nossa solução de Disaster Recovery empresarial, garantindo
                    continuidade operacional total.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      RTO de minutos com failover automático
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      RPO próximo a zero com replicação síncrona
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Múltiplos datacenters geograficamente distribuídos
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Testes de DR não-disruptivos automatizados
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Orquestração inteligente baseada em IA
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Recuperação granular por aplicação
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Relatórios de compliance automatizados
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Runbooks personalizados e documentados
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default DisasterRecoveryPage;
